import "./App.css";
import Navigation from "./Components/Navigation";
import Home from "./Components/Home/Home";
function App() {
  return (
    <>
      <Navigation />
      <Home />
    </>
  );
}

export default App;
